<script setup lang="ts">
import { BlockHeader } from 'duanaga-ui'
import DialogCloseButton from '@/components/DialogCloseButton.vue'

const props = withDefaults(
  defineProps<{
    closable?: boolean
    subtitle?: string
    title: string
  }>(),
  {
    closable: false,
    subtitle: ''
  }
)
</script>

<template>
  <BlockHeader class="border-b border-grey-30 px-24 pb-16 pt-24">
    <div class="flex items-start justify-between gap-16">
      <div class="space-y-4">
        <div class="text-20 font-600 text-grey-110">{{ props.title }}</div>
        <p
          v-if="props.subtitle"
          class="text-14 text-grey-70"
        >
          {{ props.subtitle }}
        </p>
      </div>
      <DialogCloseButton v-if="props.closable" />
    </div>
  </BlockHeader>
</template>
